<template>
  <div class="main-content">
    <!-- Page Header Start  -->
    <PageHeader
      :pageHeaderBackgroundImageSrc="item?.imageURL"
      :hasOverlay="true"
      :headerBackgroundOpacity="0.7"
    >
      <PageHeaderTitleContent>
        <div class="w-100 d-flex flex-column justify-content-center align-items-center">
          <TitleTextContent
            :titleText="item?.title"
          />
          <div style="width: 40%" class="d-flex justify-content-center mt-3">
            <div class="w-100 d-flex flex-column flex-lg-row flex-xl-row align-items-center justify-content-center justify-content-lg-between justify-content-xl-between">
              <router-link :to="{ 
                  name: isRecentPapers === true ? 'white-papers' : 'white-papers-archives', 
                  query: { 
                    paperPage: paperPage, 
                    query: query,
                  } 
                }"
              >
                <v-btn
                  rounded
                  large
                  dark
                  :color="'#424EC4'"
                >
                  Read All Papers
                </v-btn>
              </router-link>

              <v-btn
                class="mt-3 mt-lg-0 mt-xl-0"
                rounded
                large
                dark
                :color="'#424EC4'"
                @click="() => downloadWhitePaper(item?.whitepaperLink)"
              >
                Download White Paper 
              </v-btn>
            </div>
          </div>
        </div>
      </PageHeaderTitleContent>
    </PageHeader>
    <!-- Page Header End -->

    <!-- Start Top Social Media -->
    <SocialMediaWidgets
      :title="title"
      :description="description"
      :type="'blogs-top'"
      :isSocialMediaSiblingsVisible="true"
      :socialShareColumnClass="isRecentDate(item.date) ? 'col-12' : 'col-6'"
    >
      <div class="col-6 col-lg-3 col-xl-3 p-0">
        <p class="post-snippet text-start">{{ item?.author }}</p>
      </div>
      <div v-if="isRecentDate(item.date)" class="col-6 col-lg-3 col-xl-3 p-0">
        <p class="post-snippet text-right text-lg-left text-xl-left">{{ getFormattedDate(item?.date) }}</p>
      </div>
    </SocialMediaWidgets>
    <!-- End Top Social Media -->

    <section class="section-content">
      <div class="container-fluid my-3 px-3 px-lg-5 px-xl-5">
        <!-- Blog Details Start -->
        <span v-html="item?.article">
        </span>
        <!-- Blog Details End -->

        <!-- Start Read Previous and Next Article -->
        <div class="row m-0">
          <div 
            class="col-12 col-lg-6 col-xl-6 p-0 mb-lg-0 mb-xl-0 d-flex flex-row justify-content-center justify-content-lg-start justify-content-xl-start"
            :class="previousButtonMarginBottomClass"
          >
            <v-btn
              v-if="previousPaperId" 
              rounded
              large
              dark
              :color="'#424EC4'"
              width="240"
              @click="() => goToPreviousOrNextBlogItem(previousPaperId, '#/white-paper-detail')"
            >
              Read Previous
            </v-btn>
          </div>

          <div 
            class="col-12 col-lg-6 col-xl-6 p-0 mt-lg-0 mt-xl-0 d-flex flex-row justify-content-center justify-content-lg-end justify-content-xl-end"
            :class="nextButtonMarginTopClass"
          >
            <v-btn
              v-if="nextPaperId" 
              rounded
              large
              dark
              :color="'#424EC4'"
              width="240"
              @click="() => goToPreviousOrNextBlogItem(nextPaperId, '#/white-paper-detail')"
            >
              Read Next
            </v-btn>
          </div>
        </div>
        <!-- End Read Previous and Next Article -->
      </div>
    </section>
  </div>
</template>
<script>
import { BFormInput } from 'bootstrap-vue';
import axios from 'axios';
import SocialShareBookmark from '../social-share-bookmark.vue';
import PageHeader from "../library/widgets/page-header.vue";
import PageHeaderTitleContent from "../library/widgets/page-header-title-content.vue";
import TitleTextContent from '../library/widgets/title-text-content.vue';
import SocialMediaWidgets from '../library/widgets/social-media-widgets.vue';
export default {
  name: 'white-paper-detail',
  components: {
    BFormInput,
    SocialShareBookmark,
		PageHeader,
		PageHeaderTitleContent,
    TitleTextContent,
    SocialMediaWidgets,
  },
  props: {
    id: String,
    paperPage: String,
    query: String,
    isRecentPapers: String,
  },
  data() {
    return {
      query: '',
      item: {},
      previousPaperId: null,
      nextPaperId: null,
      categories: [
        { name: 'Cyber Security', articles: 4 },
        { name: 'Software', articles: 5 },
        { name: 'Manufacturing', articles: 6 },
        { name: 'Learning Tools', articles: 7 },
      ],
      archives: [
        { name: 'February 2020', articles: 4 },
        { name: 'January 2020', articles: 5 },
        { name: 'June 2020', articles: 6 },
        { name: 'May 2020', articles: 7 },
      ],
      tags: [
        { name: 'Development' },
        { name: 'Security' },
        { name: 'Infrastructure' },
        { name: 'Androids' },
        { name: 'Phishing' },
        { name: 'Coronavirus' },
      ],
      linkCopyText: 'Click to copy url link',
    };
  },
  async created() {
    if (this.item) {
      this.item = await this.getResource(this.id);
    } else {
      this.$router.push({ path: 'white-papers' });
    }
  },
  mounted() {
    this.init();
  },
  computed: {
    title() {
      return this.item?.title || 'Title';
    },
    description() {
      return this.item?.headLine || 'HeadLine';
    },
    isMobile() {
      return (this.$vuetify.breakpoint.xs || this.$vuetify.breakpoint.sm);
    },
    previousButtonMarginBottomClass() {
      return this.isMobile && this.previousPaperId && this.nextPaperId ? 'mb-3' : 'mb-0';
    },
    nextButtonMarginTopClass() {
      return this.isMobile && this.nextPaperId && this.previousPaperId ? 'mt-3' : 'mt-0';
    },
  },
  methods: {
    init() {
      /* The footer height no longer needs to be set */
      // this.initFooterHeight();
    },
    initFooterHeight() {
      var footerHeight = $('footer').outerHeight();
      $('.main-content').css('margin-bottom', footerHeight);
    },
    async getResource(id) {
      const whitePaperItems = this.$store.state.whitePaperItems;
      /*  API call to server: GET /api/resources/blogs */
      axios
        .get(`/api/resources/whitepapers/${id}`)
        .then((response) => {
          if (response.data.Items.length > 0) {
            /** Does an item exist for the query id */
            this.item = response.data.Items[0];
            //console.log(response.data);
            const currentPaperIndex = whitePaperItems.findIndex(({ title }) => title === this.item.title);

            /* Get Previous Blog Item  */
            const previousBlogItem = whitePaperItems.find((_, index) => index === (currentPaperIndex - 1));
            this.previousPaperId = previousBlogItem?.id;

            /* Get Next Blog Item */
            const nextBlogItem = whitePaperItems.find((_, index) => index === (currentPaperIndex + 1));
            this.nextPaperId = nextBlogItem?.id;
          } else {
            /** If no item exists with the id, redirect to list*/
            this.$router.push({ path: 'white-papers' });
          }
        })
        .catch((error) => {
          /** On error, redirect back to list */
          console.error(error);
          this.$router.push({ path: 'white-papers' });
        });
    },
    downloadWhitePaper(whitePaperUrl) {
      window.open(whitePaperUrl, '_blank');
    }
  },
};
</script>
<style scoped>

.centered-link {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
